import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MaterialModule } from '../../../material.module'
// import { TranslateModule } from '@ngx-translate/core'

export class DialogData {
  newTour: string
  title: string
  description: string
  start: string
  optOut: string
}

@Component({
    selector: 'restricted-product-tour-dialog',
    imports: [CommonModule, MatDialogModule, MatButtonModule, MaterialModule],
    templateUrl: './tour-dialog.component.html',
    styleUrls: ['./tour-dialog.component.scss']
})
export class TourDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
    private dialogRef: MatDialogRef<TourDialogComponent>
  ) {}

  /* istanbul ignore next */
  dismissDialog() {
    localStorage.setItem('dismissDialog', 'true')
    this.dialogRef.close()
  }
}
